import EmployeeDocumentDrawer from "./employeeDocumentDrawer";
export default EmployeeDocumentDrawer;